"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const SlotCoverSnappingBase_1 = __importDefault(require("./SlotCoverSnappingBase"));
class GasketSnapping extends SlotCoverSnappingBase_1.default {
    constructor(viewer, coverComponent) {
        super(viewer, coverComponent);
        this.isEA = this.cover.partDetails.unitOfMeasurementId === 1;
    }
    getMaxComponentLength(toCoverLength) {
        return this.isEA ? this.cover.partDetails.maxStockLength : toCoverLength;
    }
}
exports.default = GasketSnapping;
